var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIc2PersonsCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 20C0 8.9543 8.9543 0 20 0C31.0457 0 40 8.9543 40 20C40 31.0457 31.0457 40 20 40C8.9543 40 0 31.0457 0 20Z",
    fill: "#0033AD",
    fillOpacity: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 21.75C14.66 21.75 10 22.92 10 25.25V27H24V25.25C24 22.92 19.34 21.75 17 21.75ZM12.34 25C13.18 24.42 15.21 23.75 17 23.75C18.79 23.75 20.82 24.42 21.66 25H12.34ZM17 20C18.93 20 20.5 18.43 20.5 16.5C20.5 14.57 18.93 13 17 13C15.07 13 13.5 14.57 13.5 16.5C13.5 18.43 15.07 20 17 20ZM17 15C17.83 15 18.5 15.67 18.5 16.5C18.5 17.33 17.83 18 17 18C16.17 18 15.5 17.33 15.5 16.5C15.5 15.67 16.17 15 17 15ZM24.04 21.81C25.2 22.65 26 23.77 26 25.25V27H30V25.25C30 23.23 26.5 22.08 24.04 21.81ZM23 20C24.93 20 26.5 18.43 26.5 16.5C26.5 14.57 24.93 13 23 13C22.46 13 21.96 13.13 21.5 13.35C22.13 14.24 22.5 15.33 22.5 16.5C22.5 17.67 22.13 18.76 21.5 19.65C21.96 19.87 22.46 20 23 20Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIc2PersonsCircle);
export default __webpack_public_path__ + "static/media/ic_2_persons_circle.11596a0d557f7dbcefe589650dd37616.svg";
export { ForwardRef as ReactComponent };